import type { ChatType } from '@form-factory/schema';
import type { StateCreator } from 'zustand';

export type ChatSlice = {
  chat: null | ChatType;
  setChat: (chat: ChatType | null) => void;
};

export const chatSlice: StateCreator<ChatSlice> = set => ({
  chat: null,
  setChat: chat => set({ chat }),
});
